import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, FormGroup, FormControl, Radio } from 'react-bootstrap';
import { FILEPICKER_KEY } from '../../constants';
import SignaturePad from 'react-signature-pad';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import ImageUploader from '../ImageUploader';

class Signature extends Component {
  filepicker = null;
  fabric = null;
  canvas = null;
  text = null;

  constructor(props) {
    super(props);
    this.state = { type: 'text', fileUrl: null, text: '', loading: false };
  }

  componentDidMount() {
    const { fabric } = require('fabric');
    this.fabric = fabric;

    this.filepicker = require('filepicker-js');
    this.filepicker.setKey(FILEPICKER_KEY);
  }

  componentWillReceiveProps(nextProps) {
    const { status, invite } = nextProps;

    if (this.props.status === actionTypes.INVITE_CREATE_REQUEST) {
      if (status === actionTypes.INVITE_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      } else if (status === actionTypes.INVITE_CREATE_SUCCESS && invite) {
        this.close();
      }
    }
  }

  componentDidUpdate(prevPros, prevState) {
    if (prevState.type !== this.state.type && this.state.type === 'text') {
      // this.renderCanvas();
    }
  }

  opened() {
    this.setState({ type: 'text', fileUrl: null, text: '', loading: false });
    this.renderCanvas();
  }

  close() {
    this.setState({ loading: false });
    this.props.onClose();
  }

  handleType(type) {
    this.setState({ type });
  }

  handleUpload(file) {
    if (file) {
      this.setState({ fileUrl: file.url });
    }
  }

  handleText(str) {
    const fabric = this.fabric;
    const canvas = this.canvas;

    if (fabric && canvas) {
      if (this.text) {
        canvas.remove(this.text);
        this.text = null;
      }

      if (str.trim() !== '') {
        const text = new fabric.Text(str.trim());
        text.setOptions({
          fontFamily: 'MrDeHaviland-Regular',
          fontSize: 70,
          fontWeight: 600,
          left: 20,
        });
        canvas.add(text);
        this.text = text;
      }

      canvas.renderAll();
    }

    this.setState({ text: str });
  }

  save(e) {
    const { type, text, fileUrl } = this.state;
    let dataUrl = null;

    e.preventDefault();
    this.props.hideAlert();

    if (type === 'text') {
      if (!text || !this.text) {
        this.props.alert('error', 'Please type your signature.');
        return false;
      } else {
        dataUrl = this.canvas.toDataURL().split(',', 2)[1];
      }
    } else if (type === 'draw') {
      if (this.refs.drawSignature.isEmpty()) {
        this.props.alert('error', 'Please draw your signature.');
        return false;
      } else {
        dataUrl = this.refs.drawSignature.toDataURL().split(',', 2)[1];
      }
    } else if (type === 'image') {
      if (!fileUrl) {
        this.props.alert('error', 'Please upload your signature.');
        return false;
      } else {
        this.setState({ loading: true }, () => {
          this.props.onSign(fileUrl);
          this.close();
        });
      }
    }

    if (dataUrl) {
      this.setState({ loading: true }, () => {
        this.filepicker.store(
          dataUrl,
          { base64decode: true },
          (FPFile) => {
            this.setState({ fileUrl: FPFile.url });
            this.props.onSign(FPFile.url);
            this.close();
          },
          (FPError) => {
            console.error(FPError);
            this.setState({ loading: false });
            this.props.alert(
              'error',
              'Oops! Your upload has failed. Please try again.'
            );
          }
        );
      });
    }
  }

  renderCanvas() {
    const fabric = this.fabric;

    if (fabric && document.getElementById('canvas')) {
      const canvas = new fabric.Canvas('canvas');

      if (this.refs.bodyContainer) {
        canvas.setWidth(568);
        canvas.setHeight(120);
      }

      this.canvas = canvas;

      if (this.state.text.trim()) {
        this.handleText(this.state.text);
      }
    }
  }

  render() {
    return (
      <Modal
        className="signature-modal"
        show={this.props.show}
        onEnter={() => this.opened()}
        onHide={() => this.close()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Your Signature</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form ref="bodyContainer" onSubmit={(e) => this.save(e)}>
            <FormGroup>
              <Radio
                name="type"
                checked={this.state.type === 'text'}
                inline
                onChange={(e) => this.handleType('text')}
              >
                Type
              </Radio>
              <Radio
                name="type"
                checked={this.state.type === 'draw'}
                inline
                onChange={(e) => this.handleType('draw')}
              >
                Draw
              </Radio>
              <Radio
                name="type"
                checked={this.state.type === 'image'}
                inline
                onChange={(e) => this.handleType('image')}
              >
                Upload an image
              </Radio>
            </FormGroup>
            <div className={`${this.state.type !== 'text' && 'hidden'}`}>
              <FormGroup>
                <FormControl
                  ref="text"
                  type="text"
                  placeholder="Please type here"
                  onChange={(e) => {
                    this.handleText(e.target.value);
                  }}
                />
              </FormGroup>
              <canvas id="canvas"></canvas>
            </div>
            {this.state.type === 'draw' ? (
              <SignaturePad ref="drawSignature" clearButton="true" />
            ) : null}
            {this.state.type === 'image' ? (
              <ImageUploader
                image={this.state.fileUrl}
                onUpload={(file) => this.handleUpload(file)}
              />
            ) : null}
            <FormGroup className="actions">
              <p className="signature-helper">
                By clicking “Sign”, you agree that the image or text you have
                provided above will be the electronic, legal representation of
                your signature for the purposes of signing a contract.
              </p>
              <button type="submit" disabled={this.state.loading}>
                {this.state.loading && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                Sign
              </button>
            </FormGroup>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  deal: state.deals.selectedDeal,
  status: state.invites.status,
  invite: state.invites.selectedInvite,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Signature);



// WEBPACK FOOTER //
// src/components/Deals/Signature.jsx